<template>
  <div class="page">
    <div class="page_header">회원가입</div>
    <div class="page_header_line"></div>
    <div class="steps">
      <div class="step active">
        <div class="step_circle">
          <img src="@/assets/images/step_check.png" />
          <div class="step_label">약관동의</div>
        </div>
      </div>

      <div class="step active">
        <div class="step_line"></div>
        <div class="step_circle">
          <img src="@/assets/images/step_check.png" />
          <div class="step_label">정보입력</div>
        </div>
      </div>

      <div class="step active">
        <div class="step_line"></div>
        <div class="step_circle">
          <img src="@/assets/images/step_check.png" />
          <div class="step_label">인증서등록</div>
        </div>
      </div>

      <div class="step active">
        <div class="step_line"></div>
        <div class="step_circle">
          <div class="step_label">심사 후 승인</div>
        </div>
      </div>
    </div>
    <div><img src="@/assets/images/approval_icon.png" class="image_div" /></div>
    <div class="approval-page__title">회원가입 <span>심사중</span></div>
    <p class="approval-page__description">
      회원 가입 신청이 완료되었습니다.<br />
      처리 결과는 심사 일자로부터 1~3일 이내에 확인 가능하며<br />
      처리가 완료되면 문자 메시지로 안내 드립니다.
    </p>
    <button class="approval-page__button" @click="goPage('home')">홈으로</button>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

const goPage = (page: string) => {
  window.scrollTo({ top: 0, behavior: "auto" });
  router.push({ name: page });
};
onMounted(() => {
  console.log('dfdfdfd')
});
</script>

<style scoped>
.page {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 100px;
}

.page_title {
  display: flex;
  flex-direction: row;
  width: 80%;
  align-items: center;
  font-family: "Noto Sans CJK KR-Bold";
  padding: 30px 0px;
}

.login_wrap {
  border: 0.1px solid #d0d0d0;
  width: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  height: 345px;
  border-radius: 15px;
  box-shadow: 4px 4px 8px 0px #0000000d;
  margin-bottom: 200px;
}

.login_btn {
  width: 341px;
  height: 51px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  font-family: "Noto Sans CJK KR-Medium";
  background: #3382e9;
  color: white;

  border-radius: 8px;
}

.page_header_line {
  width: 36px;
  border-bottom: 3px solid #000000;
  margin-bottom: 48px;
}

.page_header {
  padding: 80px 30px 15px 30px;
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 24px;
  /* text-align: center; */
}

.description {
  text-align: center;
  font-size: 18px;
  font-family: "Noto Sans CJK KR-Light";
  color: #6d6d6d;
  margin-bottom: 50px;
}
/* 
.image_div {
    margin-bottom: 30px;
} */

.steps {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 696px;
  padding-bottom: 105px;
}

.step {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.step_circle {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  width: 12px;
  height: 12px;
  background: #d8d8d8;
  position: relative;
}

.step.active .step_circle {
  border: 3px solid #337ab7;
  width: 18px;
  height: 18px;
  background: white;
}

.step.active .step_circle div {
  color: #337ab7;
}

.step_line {
  height: 2px;
  background: #d8d8d8;
  width: 214px;
}

.active .step_line {
  width: 208px;
  background: #337ab7;
}

.step_labels {
  display: flex;
  flex-direction: row;
  /* width: 765px; */
}

.step_label {
  position: absolute;
  width: 150px;
  text-align: center;
  bottom: -31px;
  font-size: 14px;
  font-family: "Noto Sans CJK KR-Regular";
  line-height: 19px;
}

.approval-page__title {
  font-size: 38px;
  font-family: "Noto Sans CJK KR-Bold";
  padding-bottom: 20px;
}

.approval-page__title span {
  font-size: 38px;
  font-family: "Noto Sans CJK KR-Light";
}

.approval-page__description {
  color: #6d6d6d;
  text-align: center;
  font-family: "Noto Sans CJK KR-Light";
  padding-bottom: 30px;
}

.approval-page__button {
  display: inline-block;
  padding: 10px 20px;
  width: 247px;
  height: 60px;
  color: #000000;
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 20px;
  border: 1px solid #bcbcbc;
  border-radius: 4px;
  background-color: transparent;
  cursor: pointer;
  margin-bottom: 250px;
}
</style>
